document.addEventListener('DOMContentLoaded', () => {
    // Add division parameters to nav-group links based on parent menu context
    const navGroupLinks = document.querySelectorAll('[data-nav-group-link]');

    // Division slug mapping
    const divisionMap = {
        'division-sport': 'sport',
        'division-security': 'security',
        'division-countermine': 'countermine-csi'
    };

    navGroupLinks.forEach(link => {
        // Find the parent level-1 menu item to determine division context
        const parentLevel1 = link.closest('.site-header__nav--main > li');

        if (!parentLevel1) {
            return;
        }

        // Check which division class the parent has
        let divisionParam = null;
        for (const [className, slug] of Object.entries(divisionMap)) {
            if (parentLevel1.classList.contains(className)) {
                divisionParam = slug;
                break;
            }
        }

        // If we found a division context, add the parameter to the URL
        if (divisionParam) {
            const url = new URL(link.href);

            // Only add parameter if it doesn't already exist
            if (!url.searchParams.has('d')) {
                url.searchParams.set('d', divisionParam);
                link.href = url.toString();
            }
        }
    });
});
